import { useCallback, useEffect, useState } from 'react';
import {
  getPastDuePayrollPeriods,
  type PastDuePayrollPeriod,
} from '../lib/payrollPastDuePeriods';
import type { PayrollPeriodSettings } from '../lib/payrollPeriodSettings';

export function usePastDuePayrollPeriods(
  businessId: string | undefined,
  payrollSettings: PayrollPeriodSettings | null,
  refreshKey = 0
) {
  const [periods, setPeriods] = useState<PastDuePayrollPeriod[]>([]);
  const [hasLoaded, setHasLoaded] = useState(false);

  const reload = useCallback(async () => {
    if (!businessId || !payrollSettings) {
      setPeriods([]);
      setHasLoaded(false);
      return;
    }

    try {
      const pastDue = await getPastDuePayrollPeriods(businessId, payrollSettings);
      setPeriods(pastDue);
    } catch (error) {
      console.error('Error loading past due payroll periods:', error);
      setPeriods([]);
    } finally {
      setHasLoaded(true);
    }
  }, [businessId, payrollSettings]);

  useEffect(() => {
    reload();
  }, [reload, refreshKey]);

  return { periods, hasLoaded, reload };
}
